/*
 * @Author: 丨小小风离丨
 * @Date: 2023-05-16 19:40:11
 * @LastEditTime: 2023-07-26 17:44:58
 * @LastEditors: 丨小小风离丨
 * @Description: 
 */

import React, { CSSProperties, FC, useState } from 'react'
import styles from '@css/crumb.module.scss'
import { Modal, ModalProps } from 'antd'

import './index.scss'

interface alertParams extends ModalProps {
    // visible: boolean | undefined
    // title?: string
    btnStyle?: CSSProperties
    bodyContent?: React.ReactElement | React.ReactChild
    content?: string,
    description?: string | React.ReactNode,
    // showBottom?:boolean,
    callok: () => void
    callcancel: () => void
}
const NormalAlert: FC<alertParams> = props => {
    return (
        <>
            <Modal
                destroyOnClose={true}
                maskClosable={false}
                {...props}
                width={props.width}
                title={props.title || '普通弹框'}
                visible={props.visible}
                onCancel={props.callcancel}
                onOk={props.callok}
                centered={true}
                wrapClassName={['selfnormalwarp', props.wrapClassName].join(' ')}
                bodyStyle={props.bodyStyle}
                closeIcon={<div className='closeIcon'></div>}
            >
                {props.bodyContent ? props.bodyContent : null}
                {props.children}
            </Modal>
        </>
    )
}

const AskAlert: FC<alertParams> = props => {
    return (
        <Modal
            bodyStyle={props.bodyStyle}
            style={props.style}
            wrapClassName={['selfnormalwarp', props.wrapClassName].join(' ')}
            visible={props.visible}
            // title={props.title}
            footer={props.footer}
            onCancel={props.callcancel}
            onOk={props.callok}
            maskClosable={props.maskClosable}
            okText={props.okText || '确定'}
            cancelText={props.cancelText || '取消'}
            centered={props.centered || false}
        // transitionName="fadexxx"
        >
            <i className='ask_bg'></i>
            <div className='content'>
                {props.content}
            </div>
            {props.description && <div className='description'>
                {props.description}
            </div>}
            {
                props.children ?
                    props.children :
                    null
            }
            <div className='buttonlist'
                style={props.btnStyle}
            >
                <div onClick={props.callok}>{props.okText || '确定'}</div>
                <div onClick={props.callcancel}>{props.cancelText || '再想想'}</div>
            </div>
        </Modal>
    )
}

export { NormalAlert, AskAlert }